module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 116
// module chunks = 60335399758886 79611799117203